(function () {
    "use strict";

    angular
        .module("app.account")
        .controller("AccountController", AccountController);

    AccountController.$inject = [
        "$timeout",
        "AccountService",
        "SharedData",
        "$cookies",
        "$rootScope",
    ];

    function AccountController(
        $timeout,
        AccountService,
        SharedData,
        $cookies,
        $rootScope
    ) {
        /* jshint validthis:true */
        var vm = this;
        vm.SharedData = SharedData;
        vm.mediaServer = null;
        vm.forgotPasswordForm = false;
        vm.loginerror = [];
        vm.importFile = [];

        vm.activate = function () {
            vm.accountLoading = true;
            $timeout(function () {
                vm.getUser();
            }, 300);
        };

        vm.getUser = function (force) {
            if (userId || getCookieByName("UserKey") || force) {
                if ($rootScope.user) {
                    return $rootScope.user;
                }
                $rootScope.user = {};
                return AccountService.getUser()
                    .then(function (result) {
                        vm.user = result;
                        $rootScope.user = result;
                        window.userId = vm.user.Id;
                        vm.accountLoading = false;
                        $(".userLogin").css("display", "flex");
                        $(".userNotLogin").css("display", "none");
                        $(".username").html(result.Name);
                        $(".userFullName").html(result.FullName);
                        angular
                            .element(".cart-controller")
                            .scope()
                            .vm.activate();
                        return result;
                    })
                    .catch(function (error) {
                        vm.accountLoading = false;
                    });
            } else {
                $(".userLogin").css("display", "none");
                $(".userNotLogin").css("display", "flex");
                vm.user = undefined;
                $rootScope.user = null;
                window.userId = null;
                vm.accountLoading = false;
                return undefined;
            }
        };

        vm.getSales = function (id) {
            AccountService.getSales(id).then(function (response) {
                var selectedData = response;

                vm.printOrderDetails = async function () {
                    var getPaymentMethodType =
                        selectedData.Payment[0].PaymentMethod;
                    var getPaymentStatus =
                        selectedData.Payment[0].PaymentStatus;
                    var printContents = "";
                    var jsonParse = function (objString) {
                        if (typeof objString !== "string") {
                            return "";
                        }
                        var result = JSON.parse(objString);
                        if (typeof result === "string") {
                            return vm.jsonParse(result);
                        }
                        return result;
                    };

                    var cargoBarcode =
                        "https://barcode.tec-it.com/barcode.ashx?code=Code128&modulewidth=fit&data=";
                    cargoBarcode +=
                        selectedData.Code === undefined
                            ? "0"
                            : selectedData.Code;
                    var orderdateAndCode = `
                                <div class="row">
                                    <div class="column">
                                        <h1 style="font-size: 16px; font-family: arial, sans-serif;">Sipariş Tarihi/Kodu:</h1>
                                        <h1 style="font-size: 16px; font-family: arial, sans-serif;">${new Date(
                        Date.parse(
                            selectedData.OrderDate
                        )
                    ).toLocaleDateString() +
                        "/" +
                        (selectedData.Code === undefined
                            ? ""
                            : selectedData.Code)
                        }</h1>
                                    </div>
                                    <div class="column">
                                      <img src="${cargoBarcode}" style="max-height: 75px; float:right;"/>
                                    </div>
                                </div>`;
                    printContents += orderdateAndCode;
                    var paymentArea = `<div>
                                        <table>
                                          <tr>
                                            <th style="text-align: center; width: 300px;">Odeme Tipi</th>
                                            <th style="text-align: center; width: 300px;">Banka</th>
                                            <th style="text-align: center; width: 220px;">Tutar</th>
                                            <th style="text-align: center; width: 220px;">Banka Komisyonu</th>
                                            <th style="text-align: center; width: 220px;">Kargo Bedeli</th>
                                            <th style="text-align: center; width: 220px;">Kapıda Odeme Tutarı</th>
                                            <th style="text-align: center; width: 60px;">Taksit</th>
                                            <th style="text-align: center; width: 300px;">Kart No</th>
                                            <th style="text-align: center; width: 150px;">Durum</th>
                                          </tr>
                                          <tr>
                                              <td style="text-align: left;">${getPaymentMethodType.Name ===
                            null
                            ? ""
                            : getPaymentMethodType.Name
                        }</td>
                                              <td style="text-align: left;">${selectedData.Payment[0].Bank
                            .Name === null
                            ? ""
                            : selectedData.Payment[0]
                                .Bank.Name
                        }</td>
                                              <td style="text-align: center;">${selectedData.Payment[0]
                            .ExpectedTotal === null
                            ? ""
                            : selectedData.Payment[0].ExpectedTotal.toFixed(
                                2
                            )
                        }</td>
                                              <td style="text-align: center;">0.00</td>
                                              <td style="text-align: center;">${selectedData.ShippingPrice.toFixed(
                            2
                        )}</td>
                                              <td style="text-align: center;">${selectedData.ServicePrice.toFixed(
                            2
                        )}</td>
                                              <td style="text-align: center;">${selectedData.Payment[0]
                            .Installment === null
                            ? ""
                            : selectedData.Payment[0]
                                .Installment
                        }</td>
                                              <td style="text-align: center;">${selectedData.Payment[0]
                            .MaskedCreditCard ===
                            undefined
                            ? ""
                            : selectedData.Payment[0]
                                .MaskedCreditCard
                        }</td>
                                              <td style="text-align: center;">${!(getPaymentStatus.Name ===
                            null
                            ? ""
                            : getPaymentStatus.Name)
                            ? ""
                            : getPaymentStatus.Name ===
                                null
                                ? ""
                                : getPaymentStatus.Name
                        }</td>
                                          </tr>
                                      </table>
                                </div>`;
                    printContents += paymentArea;
                    var deliveryArea = `
                        <div class="row">
                            <div class="column">
                              <h1 style="font-size: 14px;">Teslimat Bilgileri</h1>
                            <table>
                          <tr>
                            <th style="height: 15px; width: 200px;">İsim Soyisim</th>
                            <td style="height: 15px; width: 800px">${selectedData.Customer.FullName
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 45px;">Adres</th>
                            <td style="height: 45px;">${!selectedData.DeliveryAddress
                            ? ""
                            : selectedData.DeliveryAddress.FullAddress
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">Ülke/ İl/ İlçe</th>
                            <td style="height: 15px;">${(selectedData.DeliveryAddress.Country ===
                            undefined
                            ? "Türkiye"
                            : selectedData.DeliveryAddress.Country) +
                        (selectedData.DeliveryAddress
                            .StateProvinceName === null
                            ? ""
                            : "/" +
                            selectedData.DeliveryAddress
                                .StateProvinceName) +
                        (selectedData.DeliveryAddress.DistrictName ===
                            null
                            ? ""
                            : "/" +
                            selectedData.DeliveryAddress.DistrictName)
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">TCKN</th>
                            <td style="height: 15px;">${selectedData.DeliveryAddress.TcNo === undefined
                            ? "1111111111"
                            : selectedData.DeliveryAddress.TcNo
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">Telefon</th>
                            <td style="height: 15px;">${selectedData.Customer.PhoneNumber === undefined
                            ? ""
                            : selectedData.Customer.PhoneNumber
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">E-Posta</th>
                            <td style="height: 15px;">${selectedData.Customer.Email === null
                            ? ""
                            : selectedData.Customer.Email
                        }</td>
                          </tr>
                            </table>
                            </div>
                            <div class="column">
                                <h1 style="font-size: 14px;">Fatura Bilgileri</h1>
                            <table>
                          <tr>
                            <th style="height: 15px;  width: 200px;">Fatura Ünvanı</th>
                            <td style="height: 15px;  width: 800px;">${selectedData.InvoiceAddress.User === null
                            ? ""
                            : selectedData.InvoiceAddress.User
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">İsim Soyisim</th>
                            <td style="height: 15px;">${selectedData.InvoiceAddress.User === null
                            ? ""
                            : selectedData.InvoiceAddress.User
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">Vergi No/Dairesi</th>
                            <td style="height: 15px;">${(selectedData.InvoiceAddress.TcNo === undefined
                            ? selectedData.InvoiceAddress.TaxNumber
                            : selectedData.InvoiceAddress.TcNo) ===
                            undefined
                            ? ""
                            : (selectedData.InvoiceAddress.TcNo === null
                                ? selectedData.InvoiceAddress
                                    .TaxNumber
                                : selectedData.InvoiceAddress.TcNo) +
                                "/" +
                                (selectedData.InvoiceAddress
                                    .TaxOffice === null
                                    ? ""
                                    : selectedData.InvoiceAddress
                                        .TaxOffice) ===
                                null
                                ? ""
                                : selectedData.InvoiceAddress.TaxOffice ===
                                    null
                                    ? ""
                                    : selectedData.InvoiceAddress.TaxOffice
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">Telefon</th>
                            <td style="height: 15px;">${selectedData.InvoiceAddress.Phone1 === null
                            ? selectedData.InvoiceAddress.Phone2
                            : selectedData.InvoiceAddress.Phone1
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 45px;">Adres</th>
                            <td style="height: 45px;">${(selectedData.InvoiceAddress.FullAddress ===
                            null
                            ? ""
                            : selectedData.InvoiceAddress.FullAddress) +
                        "/" +
                        (selectedData.InvoiceAddress.ZipPostalCode ===
                            undefined
                            ? ""
                            : selectedData.InvoiceAddress.ZipPostalCode)
                        }</td>
                          </tr>
                          <tr>
                            <th style="height: 15px;">Ülke/ İl/ İlçe</th>
                            <td style="height: 15px;">${(selectedData.InvoiceAddress.Country ===
                            undefined
                            ? "Türkiye"
                            : selectedData.InvoiceAddress.Country) +
                        (selectedData.InvoiceAddress
                            .StateProvinceName === null
                            ? ""
                            : "/" +
                            selectedData.InvoiceAddress
                                .StateProvinceName) +
                        (selectedData.InvoiceAddress.DistrictName ===
                            null
                            ? ""
                            : "/" +
                            selectedData.InvoiceAddress.DistrictName)
                        }</td>
                          </tr>
                            </table>
                            </div>
                        </div>
                    <p></p>
                    `;
                    printContents += deliveryArea;
                    var productsHead = `
                <div>
		            <table style="margin-right: -10px; margin-top: 5px;">
                    <tr>
                        <th style="text-align: center; width: 8%;">Resim</th>
                        <th style="text-align: center; width: 15%;">Ürün Kodu</th>
                        <th style="text-align: center; width: 15%;">Barkod</th>
                        <th style="text-align: center; width: 26%;">Ürün Adı</th>
                        <th style="text-align: center; width: 2%;">Miktar</th>
                        <th style="text-align: center; width: 10%;">Birim Fiyatı</th>
                        <th style="text-align: center; width: 6%;">KDV</th>
                        <th style="text-align: center; width: 10%;">Toplam</th>
                    </tr>
                `;
                    printContents += productsHead;

                    var productList = "";

                    selectedData.OrderProduct.forEach(function (element) {
                        var elementVariant = "";

                        Object.values(
                            jsonParse(element.Product.ProductVariantString)
                        ).forEach(function (value) {
                            elementVariant += value;
                        });

                        productList =
                            productList +
                            `
                    <tr id='pageBr'>
                        <td style="text-align: left;"><img src="${vm.mediaServer +
                            "/" +
                            (element.Product.FirstImage === null
                                ? "no-image.png"
                                : element.Product.FirstImage)
                            }" style="height:50px"/></td>
                        <td style="text-align: left;">${element.Code}</td>
                        <td style="text-align: left;">${element.Product.Barcode === undefined
                                ? " "
                                : element.Product.Barcode
                            }</td>
                        <td style="text-align: left;">${element.Name +
                            " " +
                            (!elementVariant ? " " : "(" + elementVariant + ")")
                            }</td>
                        <td style="text-align: center;">${element.Quantity}</td>
                        <td style="text-align: center;">${element.UnitPriceWithDiscount.toFixed(2) +
                            " " +
                            element.Currency.Symbol
                            }</td>
                        <td style="text-align: center;">${element.Tax}</td>
                        <td style="text-align: center;">${(
                                element.UnitPriceWithDiscount *
                                element.Quantity *
                                element.Currency.Rate
                            ).toFixed(2) + element.Currency.Symbol
                            }</td>
                    </tr>

                `;

                        //for (const [key, value] of jsonParse(element.VariantValues)) {
                        //}
                    });

                    printContents += productList + `</table></div>`;

                    var subTotal = `
            <p> </p>
                    <div class="row">
                        <div class="column">
                        </div>
                        <div class="column">
                        <table class="subtotal">
                      <tr>
                        <th style="height: 15px;">Hediye Çeki İndirimi</th>
                        <td style="height: 15px;">0,00 </td>
                      </tr>
                      <tr>
                        <th style="height: 15px; width: 70%;">Ara Toplam</th>
                        <td style="height: 15px; width: 30%;">${(
                            selectedData.SubTotal -
                            selectedData.SubTotalDiscount
                        ).toFixed(2) +
                        "" +
                        selectedData.Currency.Symbol
                        }</td>
                      </tr>
                      <tr>
                        <th style="height: 15px;">Kdv Toplam</th>
                        <td style="height: 15px;">${(
                            selectedData.TotalTax -
                            selectedData.TotalTaxDiscount
                        ).toFixed(2) +
                        "" +
                        selectedData.Currency.Symbol
                        }</td>
                      </tr>
                      <tr>
                        <th style="height: 15px;">Genel Toplam</th>
                        <td style="height: 15px;">${selectedData.Payment[0].ExpectedTotal.toFixed(2) +
                        "" +
                        selectedData.Currency.Symbol
                        }</td>
                      </tr>
                      <tr>
                        <th style="height: 15px;">Kalan Bakiye</th>
                        <td style="height: 15px;">0,00</td>
                      </tr>
                      <tr>
                      </tr>
                        </table>
                        </div>
                    </div>
            `;

                    printContents += subTotal;

                    var footer = `  <footer>
                                <div>
                                  <p style="text-align:center; color:#D3D3D3; font-size: 12px;">Mazaka Yazılım E-Ticaret Sistemleriyle Yazılmıştır</p>
                              </div>
                            </footer>`;

                    printContents += footer;

                    var popupWin = window.open("", "_blank", "");
                    popupWin.document.open();
                    var printContent = `

                                <html>
                                    <body onload="window.print()">
                                   ${printContents}
                                    </body>
                                         <style>
                                                *{
                                                   box-sizing: border-box;
                                                    }
                                                    .row
                                                    {
                                                      margin-left:-10px;
                                                      margin-right:-10px;
                                                    }
                                                    .column
                                                    {
                                                      float: left;
                                                      width: 50%;
                                                      padding: 10px;
                                                    }
                                                    .row::after
                                                    {
                                                      content: "";
                                                      clear: both;
                                                      display: table;
                                                    }
                                                    table
                                                    {
                                                      font-family: arial, sans-serif;
                                                      border-collapse: collapse;
                                                      width: 100%;
                                                      font-size: 10px;
                                                    }
                                                    td, th
                                                    {
                                                      border: 1px solid #000000;
                                                      text-align: left;
                                                      padding: 5px;
                                                    }
                                                    img
                                                    {
                                                        max-width:100%;
                                                        height: auto;
                                                        width: auto;
                                                    }

                                                    .subtotal{ page-break-inside:avoid; page-break-after:auto; float: right; }

                                                    table { page-break-inside:auto }
                                                    tr    { page-break-inside:avoid; page-break-after:auto }
                                                    thead { display:table-header-group }
                                                    tfoot { display:table-footer-group }

                                    </style>
                                </html>`;

                    popupWin.document.write(printContent);
                    popupWin.document.close();
                };

                vm.printOrderDetails();
            });
        };

        vm.login = function () {
            vm.accountLoading = true;
            if (vm.loginform.$valid) {
                vm.loginerror = [];
                AccountService.login(vm.loginData).then(
                    function (result) {
                        vm.accountLoading = false;
                        $("#accountModal").modal("hide");
                        vm.getUser(true);
                    },
                    function (error) {
                        if (error.data.error_description) {
                            vm.loginerror.push(error.data.error_description);
                        } else {
                            if (error.data.Email) {
                                vm.loginerror.push(error.data.Email[0]);
                            }
                            if (error.data.Password) {
                                vm.loginerror.push(error.data.Password[0]);
                            }
                        }
                        vm.accountLoading = false;
                    }
                );
            } else {
                vm.accountLoading = false;
            }
        };

        vm.signup = function () {
            vm.accountLoading = true;
            vm.accountDisabled = true;
            if (vm.signupform.$valid) {
                vm.signuperror = [];
                var dataArray = $("#Register").serializeArray();
                var dataObj = {};
                $(dataArray).each(function (i, field) {
                    dataObj[field.name] = field.value;
                });
                var getRecaptchaValue = dataObj["g-recaptcha-response"];
                vm.signupData.GRecaptchaResponse = getRecaptchaValue;
                var SelectedContractIds = [];
                for (var key in vm.signupData.SelectedContract) {
                    if (vm.signupData.SelectedContract.hasOwnProperty(key) && vm.signupData.SelectedContract[key] === true) {
                        SelectedContractIds.push(key);
                    }
                }
                vm.signupData.SelectedContractIds = SelectedContractIds;
                vm.signupData.SelectedContract = null;

                AccountService.signup(vm.signupData).then(
                    function () {
                        vm.accountLoading = false;
                        vm.accountDisabled = false;
                        $("#accountModal").modal("hide");
                        vm.getUser(true);
                    },
                    function (error) {
                        if (error.data.error_description) {
                            vm.signuperror.push(error.data.error_description);
                        } else {
                            var values = Object.values(error.data);
                            for (var i = 0; i < values.length; i++) {
                                var item = values[i];

                                if (Array.isArray(item)) {
                                    //vm.signuperror.push(item[0]);
                                    for (var j = 0; j < item.length; j++) {
                                        var subitem = item[j];
                                        vm.signuperror.push(subitem);
                                    }
                                } else {
                                    vm.signuperror.push(item);
                                }
                            }
                        }
                        vm.accountLoading = false;
                        vm.accountDisabled = false;
                    }
                );
            } else {
                vm.accountLoading = false;
                vm.accountDisabled = false;
            }
        };

        vm.forgotPassword = function () {
            vm.accountLoading = true;
            if (vm.forgotPasswordForm.$valid) {
                vm.loginerror = [];
                vm.warningerror = [];
                AccountService.forgotPassword(vm.forgotPasswordData).then(
                    function (result) {
                        vm.warningerror.push(result.message);
                        vm.accountLoading = false;
                    },
                    function (error) {
                        if (error.data.error_description) {
                            vm.loginerror.push(error.data.error_description);
                        } else {
                            if (error.data.Email) {
                                vm.loginerror.push(error.data.Email[0]);
                            }
                            if (error.data.Password) {
                                vm.loginerror.push(error.data.Password[0]);
                            }
                        }
                        vm.accountLoading = false;
                    }
                );
            } else {
                vm.accountLoading = false;
            }
        };
        vm.saveWithoutMemberEmail = function () {
            if (vm.frmGuestUserEmail.$valid) {
                vm.guestUserEmail = vm.guestUserEmail.trim();
                if (vm.guestUserEmail.length > 0) {
                    AccountService.saveWithoutMemberEmail(vm.guestUserEmail)
                        .then(function (result) {
                            vm.accountLoading = false;
                            $("#accountModal").modal("hide");
                            window.userId = result;
                            window.cartCallback.click();
                        })
                        .catch(function (error) {
                            vm.accountLoading = false;
                            vm.saveWithoutMemberEmailMessage =
                                error.data.error_description;
                        });
                }
            }
        };
        vm.removeAccount = function () {
            var answer = window.confirm(
                "Hesabınızı silmek istediğinize emin misiniz?"
            );
            if (answer) {
                AccountService.removeAccount()
                    .then(function (result) {
                        alert("Hesabınız silindi.");
                        window.location = "/";
                    })
                    .catch(function (error) {
                        vm.accountLoading = false;
                        alert("İşlem sırasında hata oluştu.");
                    });
            }
        };
        function getCookieByName(name) {
            return $cookies.get(name);
        }

        vm.userLoginSignupVisibilityToggle = function () {
            $("#userAccountDrawer").toggleClass("end-0");
            $(".user-account__backdrop-shade").toggleClass(
                "end-0 col-12 top-0"
            );
        };

        vm.fastLoginValidate = function () {
            vm.accountLoading = true;
            if (vm.loginform.$valid) {
                AccountService
                    .fastLoginValidate({
                        PhoneNumber: vm.fastLoginData.PhoneNumber,
                        Code: vm.fastLoginData.Code
                    })
                    .then(
                        function (result) {
                            vm.accountLoading = false;
                            $("#accountModal").modal("hide");
                            vm.getUser(true);
                        },
                        function (error) {
                            if (error.data.error_description) {
                                vm.loginerror.push(error.data.error_description);
                            } else {
                                if (error.data.Email) {
                                    vm.loginerror.push(error.data.Email[0]);
                                }
                                if (error.data.Password) {
                                    vm.loginerror.push(error.data.Password[0]);
                                }
                            }
                            vm.accountLoading = false;
                        }
                    );
            } else {
                vm.accountLoading = false;
            }
        }

        vm.fastLogin = function () {
            vm.accountLoading = true;
            AccountService.fastLogin({ PhoneNumber: vm.fastLoginData.PhoneNumber }).then(
                function (result) {
                    vm.accountLoading = false;
                    vm.fastLoginCode = true;
                },
                function (error) {
                    console.log("error", error);
                    if (error.data.error_description) {
                        vm.loginerror.push(error.data.error_description);
                    } else if (error.data.Message) {
                        vm.loginerror.push(error.data.Message);
                    } else {
                        if (error.data.Email) {
                            vm.loginerror.push(error.data.Email[0]);
                        }
                        if (error.data.Password) {
                            vm.loginerror.push(error.data.Password[0]);
                        }
                    }
                    vm.accountLoading = false;
                }
            );
        }
    }
})();
